import React, { Component } from 'react'
import {
  Button,
  ButtonToolbar
} from 'react-bootstrap'

import { BootstrapTable } from 'react-bootstrap-table'
import 'react-bootstrap-table/dist/react-bootstrap-table.min.css'
import FontAwesome from 'react-fontawesome'
import { blockingFetchService } from '../../lib/blockingFetch'
import apiServerApi from '../../redux/sagas/apiServerApi'
import OrganizationActivity from './OrganizationActivity'

class OrganizationTable extends Component {

  state = {
    showRemoveModal: false,
    itemSelected: false,
    selectedRow: { id: null },
    selectRowProp: {
      mode: "radio",
      clickToSelect: true,
      hideSelectColumn: true,
      bgColor: "#9bbfdd",
      onSelect: (row, isSelected, e) => this.onRowSelect(row, isSelected, e)
    },
    checkActivityRunning: false,
    checkActivityError: '',
    activity: 0,
    nbLoan: 0,
  }

  onRowSelect(row, isSelected, e) {
    if(isSelected === true) {
      this.setState({ selectedRow: row })
    }
    this.setState({ itemSelected: isSelected })
  }

  closeRemoveModal = () => this.setState({ showRemoveModal: false })

  showRemoveDialog = () => this.setState({ showRemoveModal: true })

  /**
   * Remove action
   */
  doRemoveAction = () => {

    const id = this.getOrganizationToUpdate().id
    blockingFetchService(
      accessToken => apiServerApi.changeOrganizationStatus(accessToken, id, false), 
      rep => this.changeStatusSuccess(rep),
      error => this.changeStatusFailure(error),
      () => {}
    )

    this.closeRemoveModal()
    this.setState({ itemSelected: false })  
  }

  changeStatusSuccess = () => {
    this.closeRemoveModal()
    this.props.loadOrganizations()
    this.setState({
      checkActivityRunning: false,
      checkActivityError: '',
    })
  }

  changeStatusFailure = error => this.setState({
    checkActivityRunning: false,
    checkActivityError: error.text,
  })

  getOrganizationToUpdate = () => this.state.selectedRow

  renderContent = () => {

    const { items, children, addNewHandler, addNewLabel } = this.props,
    { selectRowProp, showRemoveModal, checkActivityRunning, checkActivityError } = this.state

    return (
      <div>

        <BootstrapTable 
          data={ items }
          striped
          hover
          condensed
          selectRow={ selectRowProp }
          pagination>
          { children }
        </BootstrapTable>

        <ButtonToolbar className='tableToolbar'>
          <Button bsStyle='primary' onClick={ addNewHandler }>
            <FontAwesome name='plus-circle' size="lg" /> { addNewLabel }
          </Button>
        </ButtonToolbar>

        <OrganizationActivity
          organization={ this.getOrganizationToUpdate() }
          show={ showRemoveModal }
          close={() => this.closeRemoveModal() }
          doAction={() => this.doRemoveAction() }
          activityRunning={ checkActivityRunning }
          activityError={ checkActivityError }
        />
      </div>
    )
  }

  render() {
    return this.props.loading ? <p>Loading...</p> : this.renderContent()
  }
}

export default OrganizationTable



// WEBPACK FOOTER //
// ./src/components/Organizations/OrganizationTable.js